import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

export const Banner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-14%", "14%"]);

  return (
    <section ref={ref} data-testid="banner-parallax" className="relative overflow-hidden">
      <motion.img
        style={{ y }}
        src={IMAGES.banner}
        alt="Familia extensa tomada de la mano al atardecer"
        loading="lazy"
        className="absolute -top-[14%] left-0 h-[128%] w-full object-cover will-change-transform"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#06273B]/85 via-[#0C5F8A]/70 to-[#0C5F8A]/55" />
      <div className="relative z-10 mx-auto max-w-4xl px-5 py-24 text-center sm:px-8 sm:py-32">
        <Reveal>
          <span className="mx-auto mb-8 block h-1 w-16 rounded-full bg-[#F5B21B]" />
          <p
            data-testid="banner-quote"
            className="font-editorial text-3xl leading-snug text-white sm:text-4xl lg:text-[2.75rem]"
          >
            “Tres generaciones, una misma promesa: estar contigo cuando importa.”
          </p>
        </Reveal>
      </div>
    </section>
  );
};
